import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import Tabs, { tabsClasses } from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

// Speed Dial - Start
import Box from "@mui/material/Box";
import { connect } from "react-redux";
import composedPoliciesAndProcedureContainer from "../../../containers/PoliciesAndProcedureContainer";
import PoliciesAndProceduresDesktop from "./PoliciesAndProceduresDesktop";
import PoliciesAndProceduresMobile from "./PoliciesAndProceduresMobile";

const PoliciesAndProceduresDetails = ({ deviceInfo, ...props }) => {
  const [policiesAndProceduresDetails, setPoliciesAndProceduresDetails] =
    useState([]);
  const [loaderDone, setLoaderDone] = useState(false);
  useEffect(() => {
    // Fetch shift attendance details from props or API
    if (props.policies_and_procedures) {
      setPoliciesAndProceduresDetails(props.policies_and_procedures);
      setTimeout(() => {
        setLoaderDone(true);
      }, 2000); // 4000ms = 4 seconds
      // setLoaderDone(true);
    } else {
      // Placeholder for fetching data from an API or other source
      setPoliciesAndProceduresDetails([]);
      setTimeout(() => {
        setLoaderDone(true);
      }, 2000);
    }
  }, [props.policies_and_procedures]);

  return (
    <React.Fragment>
      <div className="job-bx submit-resume" id="scrollFocusElement">
        <div className="job-bx-title clearfix">
          <h5 className="font-weight-700 pull-left text-uppercase">
            Policies & Procedures
          </h5>
        </div>

        <div className="row">
          {deviceInfo == "Mobile" ? (
            <PoliciesAndProceduresMobile
              policiesList={policiesAndProceduresDetails}
            />
          ) : (
            <PoliciesAndProceduresDesktop
              policiesList={policiesAndProceduresDetails}
            />
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default composedPoliciesAndProcedureContainer(
  PoliciesAndProceduresDetails
);
